import React from 'react';
import { getColumnStyle } from '../../../../utils/formCrafter/columnWidthUtils';
import styles from './HeadingField.module.css';

/**
 * HeadingField - Atom component for heading display in forms
 *
 * @param {string} label - Heading text to display
 * @param {string} tag - HTML tag to use (h1-h6), defaults to 'h3'
 * @param {string} columnWidth - Column width (1, 1/2, 1/3, etc.)
 */
const HeadingField = ({ label, tag = 'h3', columnWidth }) => {
  const Tag = tag;
  const style = getColumnStyle(columnWidth);

  return (
    <div className={styles.headingWrapper} style={style}>
      <Tag className={styles.heading}>{label || ''}</Tag>
    </div>
  );
};

export default HeadingField;
